import styled from 'styled-components';

export const PasswordChecksSC = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 8px;
  width: 100%;
`;

export const MessageRowSC = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 0;
`;

export const IconColSC = styled.div`
  display: flex;
  margin-right: 10px;
  flex-direction: column;
`;
